<template>
  <q-card :style="$q.screen.lt.md?'':'width: 470px; max-width: 80vw;'">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <div class="q-pa-none">
          اصلاح موجودی
          {{ goodsInfo.Goods_Name }}
          <q-badge align="top" :label="goodsInfo.Goods_Code" color="red" text-color="white"/>
        </div>
        <template v-slot:action>
          <q-btn icon="close" padding="none" round flat v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section :horizontal="!$q.screen.lt.md">
      <q-card-section>
        <q-form @submit="onSubmit" @reset="onReset">
          <q-card>
            <q-card-section :style="!$q.screen.lt.md?'width: 250px':''">
              <q-chip square label="واحد شمارش">
                <q-badge class="q-ml-xs" :label="goodsInfo.Unit_Name"/>
              </q-chip>
              <q-select
                  v-model="selectedStoreId"
                  filled
                  label="انبار"
                  use-chips
                  :options="storeList"
                  option-label="StorName"
                  option-value="StorID"
                  :rules="[requireRole]"
              />
              <q-input
                  class="q-mt-xs"
                  filled
                  dir="ltr"
                  label="تعداد/مفدار"
                  v-model="selectedOperandCount"
              />
              <q-input
                  counter
                  bottom-slots
                  class="q-mt-xs"
                  filled
                  type="textarea"
                  autogrow
                  label="شرح"
                  v-model="selectedDescription"
                  :rules="[ val => val.length > 15 && val.length < 150 || 'تعداد حروف شرح کمتر از 15 حرف می باشد']"
              />
            </q-card-section>
            <q-card-actions align="center">
              <q-btn color="primary" label="تایید" icon="check" type="submit"/>
              <q-btn color="red" flat label="حذف مقادیر" icon="clear" type="reset"/>
            </q-card-actions>
          </q-card>
        </q-form>

      </q-card-section>
      <q-card-section>
        <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="تعداد کل">
          <q-badge
              dir="ltr"
              :color="goodsInfo.GStor1 + goodsInfo.GStor2 + goodsInfo.GStor3 + goodsInfo.GStor4 + goodsInfo.GStor5>0?'green-10':'red-10'"
              class="q-ml-xs">
            {{ goodsInfo.GStor1 + goodsInfo.GStor2 + goodsInfo.GStor3 + goodsInfo.GStor4 + goodsInfo.GStor5 }}
          </q-badge>
        </q-chip>
        <q-space/>
        <q-separator/>
        <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="مرکزی">
          <q-badge dir="ltr" color="deep-orange-10" class="q-ml-xs">{{
              goodsInfo.GStor1 ? goodsInfo.GStor1 : 0
            }}
          </q-badge>
        </q-chip>
        <q-space/>
        <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="فروشگاه">
          <q-badge dir="ltr" color="deep-orange-10" class="q-ml-xs">{{
              goodsInfo.GStor2 ? goodsInfo.GStor2 : 0
            }}
          </q-badge>
        </q-chip>
        <q-space/>
        <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="پل پنجم">
          <q-badge dir="ltr" color="blue" class="q-ml-xs">{{ goodsInfo.GStor3 ? goodsInfo.GStor3 : 0 }}</q-badge>
        </q-chip>
        <q-space/>
        <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="کارخانه صاف">
          <q-badge dir="ltr" color="pink" class="q-ml-xs">
            {{ goodsInfo.GStor4 ? goodsInfo.GStor4 : 0 }}
          </q-badge>
        </q-chip>
        <q-space/>
        <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="دیجیکالا">
          <q-badge dir="ltr" color="pink" class="q-ml-xs">
            {{ goodsInfo.GStor6 ? goodsInfo.GStor6 : 0 }}
          </q-badge>
        </q-chip>

        <q-space/>
        <q-chip :size="$q.screen.lt.md?'md':'md'" square flat label="انبار ضایعات">
          <q-badge dir="ltr" color="blue" class="q-ml-xs">{{ goodsInfo.GStor5 ? goodsInfo.GStor5 : 0 }}</q-badge>
        </q-chip>
      </q-card-section>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import nerdamer from 'nerdamer/nerdamer.core.js'
import 'nerdamer/Algebra.js'
import 'nerdamer/Calculus.js'
import 'nerdamer/Solve.js'

export default {
  name: "GoodsStore",
  props: {
    goodsInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedOperandType: null,
      selectedStoreId: null,
      selectedOperandCount: 0,
      selectedDescription: '',
      storeList: [],
      operandList: [
        {id: 20502, label: 'کسر از انبار'},
        {id: 20531, label: 'اضافه به انبار'},
      ]
    }
  },
  methods: {
    ...mapActions({
      setStoreList: 'Products/getStoreList',
      addItems: 'Products/insertGoodsStoreD'
    }),
    requireRole(val) {
      if (val === null || val === undefined || val === '') {
        return 'انتخاب الزامی است'
      }
    },
    onSubmit() {
      this.selectedOperandCount = this.toEnDigit(this.selectedOperandCount)
      if (this.selectedOperandCount < 0) {
        this.$q.notify({
          type: 'negative',
          color: 'negative',
          position: 'top',
          message: 'امکان ثبت مقدار منفی وجود ندارد'
        })
      } else {
        let newStockCount = 0
        let newSelectedOperandType = -1;
        switch (this.selectedStoreId.StorID) {
          case 1:
            newStockCount = nerdamer.solveEquations(`${this.goodsInfo.GStor1}+x=${this.selectedOperandCount}`, 'x').toString();
            if (parseInt(newStockCount) > 0) {
              newSelectedOperandType = 20531
            } else {
              newSelectedOperandType = 20502
            }
            break
          case 2:
            newStockCount = nerdamer.solveEquations(`${this.goodsInfo.GStor2}+x=${this.selectedOperandCount}`, 'x').toString();
            if (parseInt(newStockCount) > 0) {
              newSelectedOperandType = 20531
            } else {
              newSelectedOperandType = 20502
            }
            break
          case 3:
            newStockCount = nerdamer.solveEquations(`${this.goodsInfo.GStor3}+x=${this.selectedOperandCount}`, 'x').toString();
            if (parseInt(newStockCount) > 0) {
              newSelectedOperandType = 20531
            } else {
              newSelectedOperandType = 20502
            }
            break
          case 4:
            newStockCount = nerdamer.solveEquations(`${this.goodsInfo.GStor4}+x=${this.selectedOperandCount}`, 'x').toString();
            if (parseInt(newStockCount) > 0) {
              newSelectedOperandType = 20531
            } else {
              newSelectedOperandType = 20502
            }
            break
          case 5:
            newStockCount = nerdamer.solveEquations(`${this.goodsInfo.GStor5}+x=${this.selectedOperandCount}`, 'x').toString();
            if (parseInt(newStockCount) > 0) {
              newSelectedOperandType = 20531
            } else {
              newSelectedOperandType = 20502
            }
            break
          case 6:
            newStockCount = nerdamer.solveEquations(`${this.goodsInfo.GStor6}+x=${this.selectedOperandCount}`, 'x').toString();
            if (parseInt(newStockCount) > 0) {
              newSelectedOperandType = 20531
            } else {
              newSelectedOperandType = 20502
            }
            break
          default:
            newStockCount = 0
            newSelectedOperandType = -1
        }
        if (newSelectedOperandType !== -1) {
          this.addItems({
            Goods_ID: this.goodsInfo.Goods_ID,
            selectedDescription: newSelectedOperandType === 20531 ? `اضافه به انبار به شرح ${this.selectedDescription}` : `کسر از انبار به شرح ${this.selectedDescription}`,
            selectedOperandType: newSelectedOperandType,
            selectedStoreId: this.selectedStoreId.StorID,
            selectedOperandCount: Math.abs(parseInt(newStockCount))
          }).then((res) => {
            this.onReset()
            if (res.selectedStoreId === 1) {
              this.goodsInfo.GStor1 += (res.selectedOperandType === 20531 ? parseInt(newStockCount.toString()) : parseInt(newStockCount.toString()))
            } else if (res.selectedStoreId === 2) {
              this.goodsInfo.GStor2 += (res.selectedOperandType === 20531 ? parseInt(newStockCount.toString()) : parseInt(newStockCount.toString()))
            } else if (res.selectedStoreId === 3) {
              this.goodsInfo.GStor3 += (res.selectedOperandType === 20531 ? parseInt(newStockCount.toString()) : parseInt(newStockCount.toString()))
            } else if (res.selectedStoreId === 4) {
              this.goodsInfo.GStor4 += (res.selectedOperandType === 20531 ? parseInt(newStockCount.toString()) : parseInt(newStockCount.toString()))
            } else if (res.selectedStoreId === 5) {
              this.goodsInfo.GStor5 += (res.selectedOperandType === 20531 ? parseInt(newStockCount.toString()) : parseInt(newStockCount.toString()))
            } else if (res.selectedStoreId === 6) {
              this.goodsInfo.GStor6 += (res.selectedOperandType === 20531 ? parseInt(newStockCount.toString()) : parseInt(newStockCount.toString()))
            }
            this.goodsInfo.Goods_Stock = this.goodsInfo.GStor1 + this.goodsInfo.GStor2 + this.goodsInfo.GStor3 + this.goodsInfo.GStor4 + this.goodsInfo.GStor5 + this.goodsInfo.GStor6
          })
        }
      }
    },
    onReset() {
      this.selectedDescription = '';
      this.selectedOperandCount = 0;
      this.selectedOperandType = null;
      this.selectedStoreId = null;
    }
  },
  created() {
    this.setStoreList().then((res) => {
      this.storeList = res;
    })
  }
}
</script>

<style scoped>

</style>